import {_addCsrfToken} from "../../../app/helpers";
import { Modal, Tooltip } from 'bootstrap';
document.addEventListener('DOMContentLoaded', () => {
  const popupAddToFolder = document.querySelector('#popup_add_to_folder');

  const tooltipTriggerLikeList = document.querySelectorAll('.js--like_post_btn[data-bs-toggle="tooltip"]');

  tooltipTriggerLikeList.forEach(tooltipTriggerEl => {

    const likeTextTooltip = tooltipTriggerEl.getAttribute('data-text-like');
    const revertLikeTextTooltip = tooltipTriggerEl.getAttribute('data-text-revert-like');

    if (!likeTextTooltip || !revertLikeTextTooltip) {
      return;
    }

    const tooltip = new Tooltip(tooltipTriggerEl, {
      title: likeTextTooltip,
      content: { '.tooltip-inner': likeTextTooltip }
    });

    tooltipTriggerEl.addEventListener('show.bs.tooltip', () => {
      const newContent = tooltipTriggerEl.classList.contains('checked')
          ? revertLikeTextTooltip
          : likeTextTooltip;

      tooltip.setContent({'.tooltip-inner': newContent});
    });
  });

  function initLikes() {
    document.querySelectorAll(".js--like").forEach(function(like) {
      like.addEventListener('click', function(event) {
        const btn = event.target.closest('a.like_btn');
        if (btn) {
          event.preventDefault();

          const formData = new FormData();
          formData.append('context', btn.getAttribute('data-context'));
          formData.append('post_id', btn.getAttribute('data-id'));
          _addCsrfToken(formData);

          fetch(btn.getAttribute('data-url'), {
            method: 'POST',
            body: formData
          })
              .then(response => response.json())
              .then(res => {
                if (res.status === 'success') {
                  document.querySelectorAll('.js--like a.like_btn').forEach(button => {
                    if (res.makedAction === 'like') {
                      button.classList.add('checked');
                      if (button.hasAttribute('data-text-liked')) {
                        button.querySelector('span').textContent = button.getAttribute('data-text-liked');
                      }
                    } else {
                      button.classList.remove('checked');
                      if (button.hasAttribute('data-text-liked')) {
                        button.querySelector('span').textContent = button.getAttribute('data-text-like');
                      }
                    }
                  });
                }
              })
              .catch(error => console.error('Error:', error));
        }
      });
    });
  }

  initLikes();



  document.querySelectorAll(".js--toolbar").forEach(function(toolbarFloat) {
    let heightToolbar;
    let offsetArticleHead;
    let startOpening;

    function updateToolbarState() {
      const toolbar = document.querySelector(".toolbar");
      heightToolbar = toolbar ? toolbar.offsetHeight : 0;

      const articleHead = document.querySelector(".js--publication__item h1");
      const legalBaseHead = document.querySelector(".legal-base .sheet h1");

      if (articleHead) {
        offsetArticleHead = articleHead.getBoundingClientRect().top + window.scrollY + articleHead.offsetHeight;
      } else if (legalBaseHead) {
        offsetArticleHead = legalBaseHead.getBoundingClientRect().top + window.scrollY + legalBaseHead.offsetHeight;
      }

      startOpening = offsetArticleHead || heightToolbar;

      if (window.scrollY >= startOpening) {
        toolbarFloat.classList.add("open");
      } else {
        toolbarFloat.classList.remove("open");
      }
    }

    window.addEventListener("scroll", updateToolbarState);
    window.addEventListener("resize", updateToolbarState);
    updateToolbarState();
  });
    document.addEventListener('click', function(event) {
      const target = event.target.closest('a[href="#"][data-link]');
      if (target) {
        event.preventDefault();
        window.location.href = target.getAttribute('data-link');
      }
    });



  document.addEventListener('change', function(e) {
    if (e.target.matches('#popup_add_to_folder input[type="checkbox"]')) {
      const checkboxes = document.querySelectorAll('#popup_add_to_folder input[type="checkbox"]:checked');
      const submitButton = document.querySelector('#popup_add_to_folder .js--modal_buttons button[type="submit"]');

      if (checkboxes.length > 0) {
        submitButton.removeAttribute('disabled');
      } else {
        submitButton.setAttribute('disabled', 'disabled');
      }
    }
  });
  // document.addEventListener('change', function(e) {
  //   if (e.target.matches('#popup_add_to_folder input[type="checkbox"]')) {
  //     const submitButton = document.querySelector('#popup_add_to_folder .js--modal_buttons button[type="submit"]');
  //     submitButton.removeAttribute('disabled');
  //   }
  // });


  document.querySelectorAll("#page .js--toolbar .favorite").forEach(function(favorite) {
    favorite.addEventListener("click", function(event) {
      const btn = event.target.closest("a.btn");
      if (btn) {
        if (popupAddToFolder) {
          const myModalEl = new Modal(popupAddToFolder);
          myModalEl.show();
        }else {
          event.preventDefault();
          const redirectUrl = favorite.querySelector("a.btn").getAttribute("data-redirect");
          if (redirectUrl) {
            window.location.href = redirectUrl;
          }
        }
      }
    });
  });

if (popupAddToFolder) {
  document.querySelector("#popup_add_to_folder").addEventListener("click", function(e) {
    if (e.target.matches(".btn-add-document-in-folder")) {
      e.preventDefault();

      const formData = new FormData();

      formData.append("type", e.target.getAttribute("data-type"));
      formData.append("object_id", e.target.getAttribute("data-id"));
      formData.append("channel_id", e.target.getAttribute("data-channel_id"));
      _addCsrfToken(formData);

      document.querySelectorAll('#popup_add_to_folder input[type="checkbox"]:checked')
          .forEach(checkbox => formData.append("folder_id[]", checkbox.getAttribute('data-id')));

      fetch(popupAddToFolder.getAttribute('data-url'), {
        method: "POST",
        body: formData
      })
          .then(response => response.json())
          .then(res => {
            if (res.success === 1) {
              window.location.reload();
            } else {
              console.log(res);
            }
          })
          .catch(error => console.error(error));
    }
  });

}

});

